import * as React from 'react';
import { Field } from 'redux-form';
import map from 'lodash/map';
import renderCheckbox from '../../../components/fields/Checkbox';
import { styles, promptSpacing } from './Styles';

const CONDITIONS = require('../../Profile/Conditions.json').conditions as any;
const maxOrMin = (value) => value ? 100 : 0;
const OPTIONS = CONDITIONS.map((cond) => ({id: cond.id, name: cond.name}));
import MultiCheckbox from '../../../components/MultiCheckbox';
export default ({relationship, firstName}) => (
		<fieldset className={styles.fieldset}>
				<legend className={styles.legend}>Health Information</legend>
				<div>
					<span style={promptSpacing}>
						Select <b>{relationship == 'myself' ? 'your' : `${firstName}'s'`}</b> major areas of impairment. You may select as many as are appropriate.
					</span>
						<div className={styles.DisabilityDomainsSelector} style={{'min-width': '17em'}}>
								<Field name={`selected_disability_areas`} default={0} options={OPTIONS}
               style={{listStyle: 'none'}}
               component={MultiCheckbox} />
						</div>
				</div>
		</fieldset>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Health2.tsx